import { put, call } from "redux-saga/effects";
import { SAVE_AAROLESPERMISSION_COMPLETED,SAVE_AAROLESPERMISSION_FAILED,GET_AAROLESPERMISSION_FAILED,GET_AAROLESPERMISSION_COMPLETED,DELETE_AAROLESPERMISSION_COMPLETED,DELETE_AAROLESPERMISSION_FAILED} from "../actions/Aarolespermission";
import {AarolespermissionsAPI} from '../../utils/api/AarolespermissionsAPI';
export function* saveAarolespermission(request: any) {
 
    try {
   
         const result=yield call(AarolespermissionsAPI.saveAarolespermission, request.input);
 
        yield put({ 
            type: SAVE_AAROLESPERMISSION_COMPLETED,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_AAROLESPERMISSION_FAILED, payload: e.message });
    }
}

export function* getAarolespermission(request: any) {
    try {
      const result = yield call(AarolespermissionsAPI.getAarolespermission,request.input);
 
   //   var status = result.data;
  
          yield put({
              type: GET_AAROLESPERMISSION_COMPLETED,
              payload: result.data,
              input: request.input
          });        
          
      } catch (e) {        
          yield put({ type: GET_AAROLESPERMISSION_FAILED, payload: e.message });
      }
  }

  export function* deleteAarolespermission(request: any) {
    try {
      const result = yield call(AarolespermissionsAPI.DeleteAarolespermission,request.input);
 
    //  var status = result.data;
 
          yield put({
              type: DELETE_AAROLESPERMISSION_COMPLETED,
              payload: result.data,
              input: request.input
          });        
          
      } catch (e) {        
          yield put({ type: DELETE_AAROLESPERMISSION_FAILED, payload: e.message });
      }
  }